import { JSX } from "react";

import { cn } from "@/utils/cn.ts";

interface TvCardSkeletonProps {
  className?: string;
}

const TvCardSkeleton = ({ className }: TvCardSkeletonProps): JSX.Element => {
  return (
    <div className={cn("group/card animate-pulse", className)}>
      <div className={"relative"}>
        <div className={"bg-surface-container aspect-square h-auto w-full rounded-[1.25rem] max-lg:rounded-2xl"} />
      </div>
      <p className={"text-on-surface bg-surface-container mx-auto mt-4 h-4 w-3/4 text-center max-lg:hidden"}>&nbsp;</p>
    </div>
  );
};

export default TvCardSkeleton;
